import { render, staticRenderFns } from "./OrdersId.vue?vue&type=template&id=8bff746c&"
import script from "./OrdersId.vue?vue&type=script&lang=js&"
export * from "./OrdersId.vue?vue&type=script&lang=js&"
import style0 from "./OrdersId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VLayout})
